import { useEffect } from "react"
import { postLogDetails } from "../../../Services/APIs/appDetails"
import { useTranslation } from "react-i18next"

const PermissionPopup = (props) => {
    const { t } = useTranslation("camerapermissionerror")

    useEffect(() => {
        postLogDetails({
            uid: JSON.parse(localStorage.getItem("usertpi")).usertpi,
            app: JSON.parse(localStorage.getItem("companyBucket")).companyBucket,
            payLoad: "camera permission denied"
        })
    }, [])

    return (
        <div className="absolute top-0 camera-error-popup bg-black/[0.3] backdrop-blur-sm h-full w-full flex justify-center items-center px-6">
            <div className=" flex flex-col bg-white p-5 rounded">
                <p className=" text-2xl font-bold text-center py-3"> {t("header")}  </p>
                <p className="pb-5"> {t("message")}  </p>
                <p className=" font-normal text-sm text-black">
                    <span className=""> {t("needHelp")} </span>
                    <span className="font-bold pl-2">
                        <a href="mailto:support@toothlens.com"> {t("helpCenter")} </a>
                    </span>
                </p>
                <button
                    type="button"
                    onClick={() => window.history.back()}
                    className="bg-black text-white px-5 h-11 font-semibold text-base rounded self-end">Ok</button>
            </div>
        </div>
    )
}

export default PermissionPopup